export function authHeader () {
  return {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      'Accept': 'application/json',
  }
  /*
  let user = JSON.parse(localStorage.getItem('user'))

  if (user && user.token) {
    return { 'Authorization': 'Bearer ' + user.token, 'Content-Type': 'application/json' }
  } else {
    return {}
  }

   */
}

export function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!data.success) {
      /*
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        if (data.message === 'Unauthenticated.') {
            restartUserSession()
            location.reload(true)
            return;
        }
      }
      if (response.status === 501) {
        router.push('/maintenance')
      }*/
      const error = (data && data.error) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}

export function restartUserSession () {
  return localStorage.removeItem('user')
}

export function getBlogDetails () {
    const content = $('meta[name="blog-details"]').attr('content');

    let blog = getBlogDto()
    if (content) {
        blog = JSON.parse(content);
    }

    if (blog) {
      return blog
    } else {
      return {}
    }
}

export function getBlogDto () {
    return window.blogDto || {};
}

export function getUserDto () {
    return window.userDto || {};
}

export function setupEmbedExternalUrls() {
    $('a[externalUrl]').click(function() {
        const url = $(this).attr('href');
        window.top.postMessage({'outpostOpenExternalUrl': url}, "*");
    })
}
